import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

export const useNumberOfCollectionsInReview = () => {
  return useQuery<number>({
    queryKey: ["collectionsInReview"],
    queryFn: async () => {
      return adminApiClient.getNumberOfCollectionsInReview();
    },
  });
};
